import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=4a8775f3&"
import script from "./Safety.vue?vue&type=script&lang=js&"
export * from "./Safety.vue?vue&type=script&lang=js&"
import style0 from "./Safety.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports